import { useCustomUtilities } from '@/components/builder/utils/tailwindConfig/hooks';

import { ContextMenuPopover } from '../../properties/components/tailwindSandbox';

import { useUtilitiesContext } from './context';

function ContextMenu() {
  const { onCloseContextMenu, utilitiesContext, utilitiesContext: { rightClick: { mouse = {}, selected, custom } }, setUtilitiesContext } = useUtilitiesContext()
  const { value: customUtilities, setValue: setCustomUtilities } = useCustomUtilities()

  const handleDelete = () => {
    const newUtilities = customUtilities.filter(item => selected !== item)
    setCustomUtilities(newUtilities)
    setUtilitiesContext({ ...utilitiesContext, rightClick: {} })
    onCloseContextMenu()
  }

  const options = [
    {
      label: 'Delete',
      onClick: handleDelete,
      disabled: !custom,
    },
  ]

  return <ContextMenuPopover
    selected={selected}
    options={options}
    mouse={{ left: mouse.x + 20, top: mouse.y + 30 }}
    className='w-12'
  />
}

export default ContextMenu
